<template>
  <div class="notification-block" style="display: none;">
    <div class="notification-block_inner">
      <div class="notification-block_inner-content">
        <div class="notification-block-name">
            <span class="notification-block-name_name"></span>
        </div>
        <div class="notification-block-price">
            <span class="notification-block-price_price">{{ price }}</span>
        </div>
      </div>
      <button class="black-cross"></button>
    </div>
  </div>
</template>
<script>
  export default {
    computed: {
      price() {
        return this.$store.state.price;
      },
    },
    mounted() {
      $('.form-ch__inp').on('change', function () {
          var $bl = $('.notification-block')
          $bl
              .finish()
              .fadeIn(0)
              .fadeOut(3000)
      });
    }
  }
</script>
<style scoped lang="scss">
  
.notification-block {
  display: block;
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 90px;
  background-color: #f7f7f7;
  box-shadow: 3px 5px 24px #d0d0d0;
  z-index: 999999999 !important;
}

.notification-block  .black-cross {
  width: 60px;
  height: 60px;
  z-index: 1102;
  float: right;
  margin-top: 15px;
  border-radius: 50%;
  border: 0;
  background: url('/local/templates/re-store/img/big-cross.jpg') center center no-repeat #e7e7e7;
  background-size: auto;
}

.notification-block_inner {
  width: 1130px;
  margin: 0 auto;
  padding: 0 15px;
}

.notification-block_inner-content {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}

.notification-block-price {
  font-weight: bold;
  font-size: 21px;
}

</style>
  